import { Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { IGrupoTrabalho, ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { del, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

interface I_aux {
    list_trabalhadores: ITrabalhador[],

    list_grupos: IGrupoTrabalho[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list_grupos: React.Dispatch<React.SetStateAction<IGrupoTrabalho[]>>,
    set_obj_new_grupo: React.Dispatch<React.SetStateAction<IGrupoTrabalho | undefined>>,
    obj_new_grupo: IGrupoTrabalho | undefined,

}

export const Modaladdgrupostrabalho: React.FC<I_aux> = ({
    list_trabalhadores,
    list_grupos,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list_grupos,
    set_obj_new_grupo,
    obj_new_grupo,
}) => {
    const auth = useContext(AuthContext);
    const location = useLocation();


    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [campo_obrigatorio_nome, set_campo_obrigatorio_nome] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);

    const [pessoasSelecionadas, setPessoasSelecionadas] = useState<number[]>(obj_new_grupo?.membros ? obj_new_grupo.membros.map(membro => membro.id_trabalhador) : []);
    const [open_dialog_tem_a_certeza_que_quer_elimina, set_open_dialog_tem_a_certeza_que_quer_elimina] = useState<boolean>(false);


    const handler_add_grupo = async () => {


        try {

            setIsLoading(true);
            let res = await post(auth.token.cookie_token, 'api/trabalhadores/grupos/new', {
                payload: {
                    nome: obj_new_grupo?.nome === undefined ? '' : obj_new_grupo?.nome,
                    descricao: obj_new_grupo?.descricao === undefined ? '' : obj_new_grupo?.descricao,
                   
                    id_agri: location.state,

                },
                membros: pessoasSelecionadas.map(id => ({
                    id_trabalhador: id
                })),
            });
            if (list_grupos.length === 0) {
                set_list_grupos([res.data.result])

            } else {
                set_list_grupos((old: any) => [...old, res.data.result])

            }

            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_add_grupo", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);
        }


    }
    const handler_edit_grupo = async () => {

        try {
            setIsLoading(true);
            let res = await put(auth.token.cookie_token, 'api/trabalhadores/grupos/' + obj_new_grupo?.id_grupo, {
                payload: {
                    id_grupo: obj_new_grupo?.id_grupo === undefined ? 0 : obj_new_grupo?.id_grupo,
                    nome: obj_new_grupo?.nome === undefined ? '' : obj_new_grupo?.nome,
                    descricao: obj_new_grupo?.descricao === undefined ? '' : obj_new_grupo?.descricao,
                    id_agri: location.state,

                },
                membros: pessoasSelecionadas.map(id => ({
                    id_trabalhador: id
                })),
            });

            let aux_list = list_grupos.map((el) => {
                if (el.id_grupo === obj_new_grupo?.id_grupo) {
                    return res.data.result
                } else {
                    return el
                }
            })

            set_list_grupos(aux_list)


            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_edit_grupo", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);
        }


    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)

        set_obj_new_grupo((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    }


    const func_reset_all = () => {
        set_obj_new_grupo(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_nome(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);

    }
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    const handleTogglePessoa = (id: number) => {
        setPessoasSelecionadas((prev) =>
            prev.includes(id)
                ? prev.filter((pessoaId) => pessoaId !== id)
                : [...prev, id]
        );
    };
    const handle_delete_grupo_trabalho = async () => {
        try {
          setIsLoading(true);
    
          await del(auth.token.cookie_token, `/api/trabalhadores/grupos/${obj_new_grupo?.id_grupo}`);
          list_grupos.splice(list_grupos.findIndex((grupo) => grupo.id_grupo === obj_new_grupo?.id_grupo), 1);
          set_obj_new_grupo(undefined);
          set_open_dialog_tem_a_certeza_que_quer_elimina(false);
          func_reset_all()
    
          setMessage(operacao_sucesso);
          setOpenSnackSuccess(true);
          setIsLoading(false);
    
        } catch (error) {
          func_print("handle_delete_grupo_trabalho", error, true);
          setIsLoading(false);
          if ((error as any)?.response?.data?.message) {
            setMessage((error as any).response.data.message);
          } else {
            setMessage(operacao_erro);
          }
          setOpenSnackError(true);
        }
      }
    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    {
                        flag_open_modal_edit === true ? 'Editar Grupo de Trabalho' :
                            flag_open_modal_ver_mais === true ? 'Detalhes do Grupo de Trabalho' :
                                'Adicionar Grupo de Trabalho'
                    }
                </h2>
                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            {
                                flag_open_modal_add === false && flag_open_modal_edit === false ?

                                    <div className="flex items-center justify-end  pl-5 w-full mb-4 pr-4">

                                        <div className="flex justify-between gap-2 ">

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_flag_open_modal_edit(true)
                                                    set_flag_open_modal_add(false)
                                                    set_flag_open_modal_ver_mais(false)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <EditIcon sx={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_open_dialog_tem_a_certeza_que_quer_elimina(true)


                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            </button>

                                        </div>
                                    </div>
                                    : <></>
                            }


                            <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Designação</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_grupo?.nome || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Designação'
                                                            name="nome"
                                                            error={campo_obrigatorio_nome}
                                                            helperText={campo_obrigatorio_nome ? 'Campo obrigatório' : ''}
                                                            value={obj_new_grupo?.nome === undefined ? '' : obj_new_grupo?.nome}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Descrição</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new_grupo?.descricao || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Descrição'
                                                            name="descricao"
                                                            value={obj_new_grupo?.descricao === undefined ? '' : obj_new_grupo?.descricao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="w-full">
                                        <div className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">
                                            Trabalhadores do grupo
                                        </div>

                                        <div className="max-h-[220px] overflow-y-auto rounded-xl border border-gray-200 bg-white">
                                            {list_trabalhadores.length > 0 ? (
                                                list_trabalhadores.map((pessoa) => (
                                                    <label
                                                        key={pessoa.id_trabalhador}
                                                        className="flex items-center gap-3 px-4 py-3 border-b last:border-b-0 border-gray-100 cursor-pointer hover:bg-gray-50 transition"
                                                    >
                                                        <input
                                                            disabled={flag_open_modal_ver_mais === true}
                                                            type="checkbox"
                                                            checked={pessoasSelecionadas.includes(pessoa.id_trabalhador)}
                                                            onChange={() => handleTogglePessoa(pessoa.id_trabalhador)}
                                                            className="h-4 w-4 accent-[#c94f1e] cursor-pointer"
                                                        />
                                                        <span className="text-sm text-gray-700">{pessoa.nome}</span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div className="px-4 py-3 text-sm text-gray-500">
                                                    Sem trabalhadores disponíveis
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                {flag_open_modal_ver_mais === true ? <></> :

                                    <div className="flex justify-end w-full pt-4">
                                        <button
                                            type="button"
                                            onClick={() => {


                                                if (obj_new_grupo?.nome === undefined || obj_new_grupo.nome === '') {
                                                    set_campo_obrigatorio_nome(true);
                                                } else {

                                                    set_campo_obrigatorio_nome(false);
                                                    if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                        handler_edit_grupo()
                                                    } else if (flag_open_modal_add === true) {
                                                        handler_add_grupo()
                                                    }
                                                }
                                            }}
                                            className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                        >
                                            Guardar Informação
                                        </button>
                                    </div>
                                }
                            </div>




                        </div>
                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
                open={open_dialog_tem_a_certeza_que_quer_elimina}
                onClose={() => set_open_dialog_tem_a_certeza_que_quer_elimina(false)}
                onConfirm={handle_delete_grupo_trabalho}
                message="Deseja eliminar o registo?"
            />
        </div>



    </Modal>)

}
